import { CommitMessageDialogComponent } from '@core/components/dialogs/commit-message-dialog/commit-message-dialog.component';
import { DeleteConfirmationDialogComponent } from '@core/components/dialogs/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { PublishRevisionDialogComponent } from '@core/components/dialogs/publish-revision-dialog/publish-revision-dialog.component';
import { RestoreRevisionDialogComponent } from '@core/components/dialogs/restore-revision-dialog/restore-revision-dialog.component';

export const AppDialogs = [
  CommitMessageDialogComponent,
  RestoreRevisionDialogComponent,
  PublishRevisionDialogComponent,
  DeleteConfirmationDialogComponent,
];
